import {pages} from "../../../../shared/constants/pages";
import svgIcons from "../../../../shared/constants/icons/svg-icons";
import routesNames from "../../../../shared/constants/router";
import permissions from "../../../../shared/constants/permissions";


const smsMenu = [
  {
    text: pages.sms_configuration.sms_history_page_title,
    icon: svgIcons.history,
    routeName: routesNames.administration.smsHistory,
    permissions: [permissions.readSmsHistory]
  },
  {
    text: pages.sms_configuration.sms_credentials_page_title,
    icon: svgIcons.lock,
    routeName: routesNames.administration.smsCredentials,
    permissions: [permissions.readScopeSmsCredentials, permissions.writeScopeSmsCredentials]
  },
  {
    text: pages.sms_configuration.sms_template_page_title,
    icon: svgIcons.chat_dots,
    routeName: routesNames.administration.smsTemplates,
    permissions: [permissions.writeSmsTemplate]
  },
  {
    text: pages.sms_configuration.sms_settings_page_title,
    icon: svgIcons.lock,
    routeName: routesNames.administration.smsSettings,
    permissions: [permissions.readSmsSettings, permissions.writeSmsSettings]
  },
];

export default smsMenu;
